const ua = window.navigator.userAgent.toLowerCase(),
	appver = window.navigator.appVersion.toLowerCase();
let isLegacy =
	appver.indexOf("msie 8.0") > -1 ||
	appver.indexOf("msie 9.0") > -1 ||
	appver.indexOf("msie 10.0") > -1,
	isIE = ua.indexOf("msie") !== -1 || navigator.userAgent.match(/Trident/),
	isIE11 = navigator.userAgent.toLowerCase().indexOf("trident/7") > -1,
	isAndroid = navigator.userAgent.match(/Android/i),
	isIPhone = navigator.userAgent.match(/iPhone/i),
	isSP =navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/iPhone/i),
	isIPad = navigator.userAgent.match(/iPad/i),
	isFF = ua.indexOf("firefox") !== -1,
	isEdge = ua.indexOf("applewebkit") > -1 && ua.indexOf("edge") > -1,
	isMobile = true,
	isSmallScreen = false,
	isPC = true;

if (isAndroid || isIPhone || isIPad) {
	isPC = false;
} else {
	isPC = true;
}
var $html = document.documentElement;

let host = location.hostname;
var domain = "";

if (host.indexOf("preview.vison.jp") != -1 || host.indexOf("vison.jp") != -1) {
	domain = "";
}else{
	var domain = "https://vison.jp";
}



var apiURL = {
	category: "/api/category.php",
	tags: "/api/tags.php",
	area: "/api/city.php",
	areazone: "/api/area.php",
	option: "/api/option.php",
	eventcalendar: "/api/eventcalendar.php",
	shop: "/api/shops.php",
	shopGenre: "/api/shop_genre.php",
	initial: "/api/initials.php",
	post: "/api/articles.php",
	like: "/api/article_like.php",
	shopArea: "/api/area_shop.php"
};
//win or mac
if (navigator.userAgent.indexOf("Win") !== -1) {
	let ary = ["os_windows"];
	if (isFF) {
		ary.push("firefox");
	} else {
		if (isIE) {
			if (isIE11) {
				ary.push("ie11");
			}
		} else if (isEdge) {
			ary.push("edge");
		} else {
		}
	}
	addClassToBody(ary);
}
if (navigator.userAgent.indexOf("Mac") !== -1) {
	let ary = ["os_mac"];
	if (isFF) {
		ary.push("firefox");
	} else {
		if (ua.indexOf("safari") > -1 && ua.indexOf("chrome") === -1) {
			ary.push("safari");
		} else {
			ary = ["os_mac"];
		}
	}
	addClassToBody(ary);
}
function addClassToBody(ary) {
	for (let i = 0; i < ary.length; i++) {
		$html.classList.add(ary[i]);
	}
}
var mouse = [];
function object(o) {
	var f = object.f, i,len,n,prop;f.prototype = o;
	n = new f();
	for (i = 1, len = arguments.length; i < len; ++i) {
		for (prop in arguments[i]) {
			n[prop] = arguments[i][prop];
		}
	}
	return n;
}
object.f = function () {};

var load = {
	getJson: function (url, params) {
		var defer = $.Deferred();
		var url = url;
		$.ajax({
			type: "GET",
			dataType: "json",
			url: url,
			data: params,
			success: defer.resolve,
			error: defer.reject,
		});
		return defer.promise();
	},
	postJson: function(url, params) {
		var defer 	= $.Deferred();
		$.ajax({
			type: "POST",
			dataType: 'json',
			url: url,
			data: params,
			success	: defer.resolve,
			error: function(XMLHttpRequest, textStatus, errorThrown){
				console.log(XMLHttpRequest.responseJSON);
				defer.reject
			}
		});
		return defer.promise();
	}
};
var tag = document.createElement("script");
tag.src = "//www.youtube.com/iframe_api";
var firstScriptTag = document.getElementsByTagName("script")[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
/*! modernizr 3.6.0 (Custom Build) | MIT *
 * https://modernizr.com/download/?-fetch-webp-webpalpha-webpanimation-webplossless_webp_lossless-setclasses !*/
!function(A,e,n){function a(A){var e=c.className,n=Modernizr._config.classPrefix||"";if(u&&(e=e.baseVal),Modernizr._config.enableJSClass){var a=new RegExp("(^|\\s)"+n+"no-js(\\s|$)");e=e.replace(a,"$1"+n+"js$2")}Modernizr._config.enableClasses&&(e+=" "+n+A.join(" "+n),u?c.className.baseVal=e:c.className=e)}function o(A,e){return typeof A===e}function s(){var A,e,n,a,s,i,r;for(var f in l)if(l.hasOwnProperty(f)){if(A=[],e=l[f],e.name&&(A.push(e.name.toLowerCase()),e.options&&e.options.aliases&&e.options.aliases.length))for(n=0;n<e.options.aliases.length;n++)A.push(e.options.aliases[n].toLowerCase());for(a=o(e.fn,"function")?e.fn():e.fn,s=0;s<A.length;s++)i=A[s],r=i.split("."),1===r.length?Modernizr[r[0]]=a:(!Modernizr[r[0]]||Modernizr[r[0]]instanceof Boolean||(Modernizr[r[0]]=new Boolean(Modernizr[r[0]])),Modernizr[r[0]][r[1]]=a),t.push((a?"":"no-")+r.join("-"))}}function i(A,e){if("object"==typeof A)for(var n in A)f(A,n)&&i(n,A[n]);else{A=A.toLowerCase();var o=A.split("."),s=Modernizr[o[0]];if(2==o.length&&(s=s[o[1]]),"undefined"!=typeof s)return Modernizr;e="function"==typeof e?e():e,1==o.length?Modernizr[o[0]]=e:(!Modernizr[o[0]]||Modernizr[o[0]]instanceof Boolean||(Modernizr[o[0]]=new Boolean(Modernizr[o[0]])),Modernizr[o[0]][o[1]]=e),a([(e&&0!=e?"":"no-")+o.join("-")]),Modernizr._trigger(A,e)}return Modernizr}var t=[],l=[],r={_version:"3.6.0",_config:{classPrefix:"",enableClasses:!0,enableJSClass:!0,usePrefixes:!0},_q:[],on:function(A,e){var n=this;setTimeout(function(){e(n[A])},0)},addTest:function(A,e,n){l.push({name:A,fn:e,options:n})},addAsyncTest:function(A){l.push({name:null,fn:A})}},Modernizr=function(){};Modernizr.prototype=r,Modernizr=new Modernizr;var f,c=e.documentElement,u="svg"===c.nodeName.toLowerCase();!function(){var A={}.hasOwnProperty;f=o(A,"undefined")||o(A.call,"undefined")?function(A,e){return e in A&&o(A.constructor.prototype[e],"undefined")}:function(e,n){return A.call(e,n)}}(),r._l={},r.on=function(A,e){this._l[A]||(this._l[A]=[]),this._l[A].push(e),Modernizr.hasOwnProperty(A)&&setTimeout(function(){Modernizr._trigger(A,Modernizr[A])},0)},r._trigger=function(A,e){if(this._l[A]){var n=this._l[A];setTimeout(function(){var A,a;for(A=0;A<n.length;A++)(a=n[A])(e)},0),delete this._l[A]}},Modernizr._q.push(function(){r.addTest=i}),Modernizr.addAsyncTest(function(){var A=new Image;A.onerror=function(){i("webpalpha",!1,{aliases:["webp-alpha"]})},A.onload=function(){i("webpalpha",1==A.width,{aliases:["webp-alpha"]})},A.src="data:image/webp;base64,UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAABBxAR/Q9ERP8DAABWUDggGAAAADABAJ0BKgEAAQADADQlpAADcAD++/1QAA=="}),Modernizr.addAsyncTest(function(){var A=new Image;A.onerror=function(){i("webpanimation",!1,{aliases:["webp-animation"]})},A.onload=function(){i("webpanimation",1==A.width,{aliases:["webp-animation"]})},A.src="data:image/webp;base64,UklGRlIAAABXRUJQVlA4WAoAAAASAAAAAAAAAAAAQU5JTQYAAAD/////AABBTk1GJgAAAAAAAAAAAAAAAAAAAGQAAABWUDhMDQAAAC8AAAAQBxAREYiI/gcA"}),Modernizr.addAsyncTest(function(){var A=new Image;A.onerror=function(){i("webplossless",!1,{aliases:["webp-lossless"]})},A.onload=function(){i("webplossless",1==A.width,{aliases:["webp-lossless"]})},A.src="data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAAAAAAfQ//73v/+BiOh/AAA="}),Modernizr.addAsyncTest(function(){function A(A,e,n){function a(e){var a=e&&"load"===e.type?1==o.width:!1,s="webp"===A;i(A,s&&a?new Boolean(a):a),n&&n(e)}var o=new Image;o.onerror=a,o.onload=a,o.src=e}var e=[{uri:"data:image/webp;base64,UklGRiQAAABXRUJQVlA4IBgAAAAwAQCdASoBAAEAAwA0JaQAA3AA/vuUAAA=",name:"webp"},{uri:"data:image/webp;base64,UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAABBxAR/Q9ERP8DAABWUDggGAAAADABAJ0BKgEAAQADADQlpAADcAD++/1QAA==",name:"webp.alpha"},{uri:"data:image/webp;base64,UklGRlIAAABXRUJQVlA4WAoAAAASAAAAAAAAAAAAQU5JTQYAAAD/////AABBTk1GJgAAAAAAAAAAAAAAAAAAAGQAAABWUDhMDQAAAC8AAAAQBxAREYiI/gcA",name:"webp.animation"},{uri:"data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAAAAAAfQ//73v/+BiOh/AAA=",name:"webp.lossless"}],n=e.shift();A(n.name,n.uri,function(n){if(n&&"load"===n.type)for(var a=0;a<e.length;a++)A(e[a].name,e[a].uri)})}),Modernizr.addTest("fetch","fetch"in A),s(),a(t),delete r.addTest,delete r.addAsyncTest;for(var p=0;p<Modernizr._q.length;p++)Modernizr._q[p]();A.Modernizr=Modernizr}(window,document);